@import 'styles/mixins';
@import 'styles/variables';

.section {
  width: 100%;
}
